import React, { useEffect } from 'react';
import { useAuth0 } from '../../../providers/Auth0Provider';
import LoadingIndicator from '../../core/LoadingIndicator/LoadingIndicator';

const Login = ({ history }) => {
  const { isAuthenticated, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (isAuthenticated) {
      history.push('/mobile/trip');
    } else {
      loginWithRedirect({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoadingIndicator />;
};

export default Login;
